import { flags } from "@app/config";

/** Where the API lives: behind Discord's proxy in the Activity, behind Vite's proxy locally. */
export const IN_DISCORD = new URLSearchParams(window.location.search).has("frame_id");

/** `?mock=<userId>` runs without the Discord SDK; the server accepts it only in `local`. */
export const MOCK_USER = new URLSearchParams(window.location.search).get("mock");

export const API_BASE = IN_DISCORD ? "/.proxy/api" : "/api";

/** The speaking glow (decision 146): its Discord scope waits for Discord's approval outside test. */
export const VOICE = flags.voice?.enabled === true || import.meta.env.VITE_VOICE === "true";
export const CLIENT_ID = import.meta.env.VITE_DISCORD_CLIENT_ID ?? "";
